import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Typography from '@components/basics/typography';

interface FilterWrapperProps {
  className?: string;
  title: React.ReactNode;
}

const FilterWrapper: FunctionComponent<FilterWrapperProps> = ({
  className,
  children,
  title,
}) => {
  return (
    <div className={className || ''}>
      <Typography weight="700">{title}</Typography>
      {children}
    </div>
  );
};

export default styled(FilterWrapper)`
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  padding-top: 20px;
  display: grid;
  grid-gap: 20px;
`;
